import WxApi from '@/utils/wx_api'
const KEY = 'house_price'
let _houses_mode = null
export default {
    setMode (house_id, mode) {
        if (!_houses_mode) {
            _houses_mode = {}
        }
        _houses_mode[house_id] = mode
        WxApi.setStorage(KEY, _houses_mode)
    },
    getMode (house_id) {
        if (!_houses_mode) {
            return WxApi.getStorage(KEY).then(({ data }) => {
                _houses_mode = data
                return data[house_id]
            }).catch(() => {
                return ''
            })
        }
        return Promise.resolve(_houses_mode[house_id])
    }
}
